import { useTranslation } from "react-i18next";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import {
  CycleSharePanel,
  type CycleShareMessageVariant,
} from "@/components/v2/home/CycleSharePanel";

interface CycleShareDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  shareUrl: string | null;
  ready: boolean;
  groupName?: string;
  settingUp: boolean;
  sharePassword?: string;
  messageVariant?: CycleShareMessageVariant;
  onSetupPassword: (password: string) => Promise<string | null>;
}

export function CycleShareDialog({
  open,
  onOpenChange,
  shareUrl,
  ready,
  groupName,
  settingUp,
  sharePassword = "",
  messageVariant = "poll",
  onSetupPassword,
}: CycleShareDialogProps) {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>{t("v2.home.pollSharePromptTitle")}</DialogTitle>
          <DialogDescription>
            {ready
              ? t("v2.home.pollSharePromptDescReady")
              : t("v2.home.pollSharePromptDescSetup")}
          </DialogDescription>
        </DialogHeader>

        <CycleSharePanel
          ready={ready}
          shareUrl={shareUrl}
          sharePassword={sharePassword}
          groupName={groupName}
          settingUp={settingUp}
          messageVariant={messageVariant}
          onSetupPassword={onSetupPassword}
          onDone={() => onOpenChange(false)}
        />
      </DialogContent>
    </Dialog>
  );
}
